import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  headerTote: {
    description: 'Order info header for tote name',
    defaultMessage: 'Tote:',
    id: 'oLnBmM',
  },
  headerShipment: {
    description: 'Order info header for shipment number',
    defaultMessage: 'Shipment:',
    id: 'FhsvZW',
  },
  headerOrder: {
    description: 'Order info header for order number',
    defaultMessage: 'Order:',
    id: 'N0ErtQ',
  },
  headerShipTo: {
    description: 'Order info header for ship to address',
    defaultMessage: 'Ship To:',
    id: 'gVgAc6',
  },
  headerBatch: {
    description: 'Order info header for batch number',
    defaultMessage: 'Batch:',
    id: 'qijjIh',
  },
  itemInfoSku: {
    description: 'scan.itemInfo.sku',
    defaultMessage: 'SKU:',
    id: 'H3kl1C',
  },
  itemInfoUpc: {
    description: 'scan.itemInfo.upc',
    defaultMessage: 'UPC:',
    id: 'sqxBn2',
  },
  listHeaderVerifyAll: {
    description: 'scan.listHeader.verifyAll',
    defaultMessage: 'Verify All',
    id: 'lKoVHN',
  },
  listHeaderClearAll: {
    description: 'scan.listHeader.clearAll',
    defaultMessage: 'Clear All',
    id: 'Ws/hnK',
  },
  listHeaderOrderQty: {
    description: 'scan.listHeader.orderQty',
    defaultMessage: 'Order Qty.',
    id: '21M3nj',
  },
  listHeaderOrderItems: {
    description: 'list header for order items column',
    defaultMessage: 'Order Items',
    id: 'ErI44x',
  },
  listHeaderScanned: {
    description: 'scan.listHeader.scanned',
    defaultMessage: 'Scanned',
    id: 'QoFd/N',
  },
  verifyAndPrint: {
    description: 'scan.verifyAndPrintMode',
    defaultMessage: 'Scan to Verify & Print',
    id: '9llP37',
  },
  scanToPrint: {
    description: 'scan.scanToPrintMode',
    defaultMessage: 'Scan to Print',
    id: 'tHppcr',
  },
  verify: {
    description: 'scan verify only mode',
    defaultMessage: 'Scan to Verify',
    id: 't7NGdw',
  },
  missingPrinter: {
    description: 'scan.missingPrinter',
    defaultMessage: 'Please select a printer',
    id: 'ZhpOfG',
  },
  salesOrderListMatches: {
    description: 'scan.orderSearchHeader.matches',
    defaultMessage: 'Matches for #{searchText}',
    id: '5OlHKa',
  },
  salesOrderListMultipleMatchesOrder: {
    description: 'scan.orderSearchHeader.multipleMatchesOrder',
    defaultMessage: 'There are multiple Orders with the order #{searchText}. Please choose an order to continue:',
    id: '7Voinj',
  },
  salesOrderListMultipleMatchesShipment: {
    description: 'scan.orderSearchHeader.multipleMatchesShipment',
    defaultMessage: 'There are multiple Shipments for order #{searchText}. Please choose one to continue:',
    id: 'UO/Y/z',
  },
  printBarcodeSheet: {
    description: 'scan.printBarcodeSheet',
    defaultMessage: 'Print Barcode Sheet',
    id: 'sgj9Dx',
  },
  readyToScan: {
    description: 'scan.readyToScan',
    defaultMessage: 'Scan a packing slip.',
    id: 'pem+DT',
  },
  readyToScanToo: {
    description: 'scan.readyToScanToo',
    defaultMessage: 'You can also type in an order number.',
    id: 'AiXSC8',
  },
  scanPrintButton: {
    description: 'scan.printButton',
    defaultMessage: 'Print Label (p)',
    id: 'CDJm7t',
  },
  rateErrorTitle: {
    description: 'scan.rateError.title',
    defaultMessage: 'Unable to Calculate Rate',
    id: '12YaFB',
  },
  rateErrorBody: {
    description: 'scan.rateError.body',
    defaultMessage: 'An unexpected error occurred',
    id: '7pctsr',
  },
  reprintLabelButton: {
    description: 'scan.fulfillmentPlanner.reprintLabel',
    defaultMessage: 'Reprint Label',
    id: 'aSx83d',
  },
  invalidScanExtraProduct: {
    description: 'scan.invalidScanModal.extraProduct',
    defaultMessage: 'Extra Product Scanned',
    id: 'w2RAM2',
  },
  invalidScanAlreadyVerified: {
    description: 'scan.invalidScanModal.alreadyVerified',
    defaultMessage: 'This item quantity has already been verified.',
    id: 'ZpC2ra',
  },
  invalidScanIncorrectProduct: {
    description: 'scan.invalidScanModal.incorrectProduct',
    defaultMessage: 'Incorrect Product',
    id: 'jt4pzo',
  },
  invalidScanNotInOrder: {
    description: 'scan.invalidScanModal.notInOrder',
    defaultMessage: 'The scanned item can not be found on this order',
    id: 'fwW+/W',
  },
  invalidScanContinue: {
    description: 'scan.invalidScanModal.continue',
    defaultMessage: 'Continue (esc)',
    id: '8Ql5bV',
  },
  verificationMessage: {
    description: 'scan.verificationNotifier.scanNotifier',
    defaultMessage: '1 scanned',
    id: '3EoOdH',
  },
  verifiedFooterVerified: {
    description: 'scan.verificationFooter.verified',
    defaultMessage: 'Verified',
    id: '2s0Pok',
  },
  verifiedFooterRemaining: {
    description: 'scan.verificationFooter.remaining',
    defaultMessage: 'Remaining',
    id: 'nit2m1',
  },
  verifiedFooterVerifiedAutoConfirm: {
    description: 'Scan page footer describing autoConfirm/advance feature',
    defaultMessage: 'The workflow will automatically advance to the next step once all items are verified. {linkToWorkflow}',
    id: 'L9LTGl',
  },
  editWorkflow: {
    description: 'scan.verificationFooter.editWorkflow',
    defaultMessage: 'Edit',
    id: 'hubwsb',
  },
  verifyHeaderUpc: {
    description: 'scan.productCodeInput.upcPlaceholder',
    defaultMessage: 'Scan or enter a UPC to continue',
    id: 'Pn+ZyI',
  },
  verifyHeaderSku: {
    description: 'scan.productCodeInput.skuPlaceholder',
    defaultMessage: 'Scan or enter a SKU to continue',
    id: 'TzQs8N',
  },
  verifyHeaderBoth: {
    description: 'scan.productCodeInput.bothPlaceholder',
    defaultMessage: 'Scan or enter a UPC/SKU to continue',
    id: 'fU4xKt',
  },
  verifyHeaderSubmit: {
    description: 'scan.productCodeInput.submit',
    defaultMessage: 'Verify Item',
    id: 'Ik53Mg',
  },
  addressDropdownToggler: {
    description: 'scan.addressDropdown.toggler',
    defaultMessage: 'View',
    id: 'enPQa+',
  },
  addressDropdownMenuTitle: {
    description: 'scan.addressDropdown.buyerTitle',
    defaultMessage: 'View Buyer/Recipient Information',
    id: '24vZrH',
  },
  itemInfoMarketplaceAdjustmentMade: {
    description: 'scan marketplace adjustment made',
    defaultMessage: 'The Quantity has been adjusted by <b>{displayName}</b>.',
    id: 'rf12M6',
  },
  shipmentSectionHeader: {
    description: 'Shipment Section Header for Scan',
    defaultMessage: 'Shipment',
    id: '+6x3oG',
  },
  scannedOrderNumber: {
    description: 'scan.invalidScanModal.scannedOrderNumber',
    defaultMessage: 'It looks like you scanned a packing slip.',
    id: 'Cscm3t',
  },
  invalidScanGoToOrder: {
    description: 'scan.invalidScanModal.goToOrder',
    defaultMessage: 'Open Order (Enter)',
    id: '8BeBNZ',
  },
  invalidScanDismiss: {
    description: 'scan.invalidScanModal.dismissModal',
    defaultMessage: 'Dismiss (esc)',
    id: '3eGYa6',
  },
  workflowModeLabel: {
    description: 'Label for workflow mode dropdown',
    defaultMessage: 'Workflow',
    id: 'vJhHz7',
  },
  scanSearchLabelBasic: {
    description: 'Label for order searchbar input',
    defaultMessage: 'Order Number',
    id: 'svMkD1',
  },
  scanSearchLabelTotes: {
    description: 'Label for order searchbar input when user has access to totes',
    defaultMessage: 'Order Number or Tote Id',
    id: 'OFj5zk',
  },
  searchShipmentButton: {
    description: 'scanTo.orderSearchSubmitButton',
    defaultMessage: 'Find Shipment',
    id: 'MwPuOA',
  },
  addressPlaceholder: {
    description: 'placeholder for non-existant address',
    defaultMessage: 'N/a',
    id: 'PmZIy+',
  },
  tagsLabel: {
    description: 'Order tags label',
    defaultMessage: 'Tags:',
    id: 'ug8JFx',
  },
  queueProgressLabel: {
    description: 'Scan queue progress label',
    defaultMessage: 'Progress:',
    id: 'DJB9wi',
  },
  queueProgress: {
    description: 'Scan queue progress',
    defaultMessage: 'Order {currentIndex} of {totalCount}',
    id: '71ipQ/',
  },
  queueInterruptionConfirmTitle: {
    description: 'Scan queue interruption modal title',
    defaultMessage: 'Stop Batch Scanning?',
    id: 'oMTc9i',
  },
  queueInterruptionConfirmMessage: {
    description: 'Scan queue interruption modal body message',
    defaultMessage: 'You are currently scanning a batch of orders. Starting a new search will stop the batch scanning process.',
    id: '6PrWoq',
  },
  queueInterruptionConfirmStop: {
    description: 'Scan queue interruption modal button for stopping the batch scan',
    defaultMessage: 'Stop Batch Scanning',
    id: 'faYpG+',
  },
  queueInterruptionConfirmCancel: {
    description: 'Scan queue interruption modal button for continuing the batch scan',
    defaultMessage: 'Continue Batch Scanning',
    id: 'hW6aL+',
  },
  editVerificationButton: {
    description: 'verifySectionFooter.edit',
    defaultMessage: 'Edit Verification',
    id: 'B2kBXA',
  },
  markVerificationButton: {
    description: 'verifySectionFooter.submit',
    defaultMessage: 'Mark as Verified (v)',
    id: 'Y/FEwb',
  },
});
